import type { PageCard } from '@/play/pageTypes'
import { Ooze2CardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'ooze-2',
  number: 35,
  title: 'Ooze 2',
  question: 'Is Ooze more fun as a potion lab: choosing the potions, filling the bottles, poking holes, and watching them collect in bright bands?',
  status: 'open',
  // The newest version of 017 Ooze (docs/pages.md, Versions).
  versionOf: 'ooze',
  accent: '#3d2c52',
  CardArt: Ooze2CardArt,
}
